import { render, staticRenderFns } from "./PageTabs.vue?vue&type=template&id=241765e8&scoped=true&"
import script from "./PageTabs.vue?vue&type=script&lang=js&"
export * from "./PageTabs.vue?vue&type=script&lang=js&"
import style0 from "./PageTabs.vue?vue&type=style&index=0&id=241765e8&lang=scss&scoped=true&"
import style1 from "./PageTabs.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241765e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VChip,VTab,VTabs,VTabsItems})
